import React from 'react'
import { useIntl } from 'react-intl'
import { Box } from '@mui/material'
import { ui } from '../../../../utils/uiTokens'
import { FACTOR_META, money, SalaryConfig } from '../../../../utils/salaryFormulas'

interface Props {
    config: SalaryConfig
}

// 5 факторов с максимумами и правилами (ТЗ §3). Общий блок для админа и ментора.
const SalaryFactorRules: React.FC<Props> = ({ config }) => {
    const { formatMessage } = useIntl()

    return (
        <Box sx={styles.grid}>
            {FACTOR_META.map((f, i) => (
                <Box key={f.key} sx={styles.card}>
                    <Box sx={styles.head}>
                        <Box sx={styles.num}>{i + 1}</Box>
                        <Box sx={styles.title}>{formatMessage({ id: f.labelId })}</Box>
                        <Box sx={styles.max}>{money(config[f.maxKey])}</Box>
                    </Box>
                    <Box sx={styles.rule}>{formatMessage({ id: f.ruleId })}</Box>
                </Box>
            ))}
        </Box>
    )
}

const styles = {
    grid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
        gap: 1.5,
    },
    card: {
        border: `1px solid ${ui.border}`,
        borderRadius: ui.radius,
        padding: '14px 16px',
        backgroundColor: ui.card,
    },
    head: {
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        marginBottom: '8px',
    },
    num: {
        width: 24,
        height: 24,
        borderRadius: '7px',
        backgroundColor: ui.pinkSoft,
        color: ui.pink,
        fontWeight: 700,
        fontSize: '12px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
    },
    title: { fontWeight: 600, fontSize: '14px', color: ui.ink, flexGrow: 1 },
    max: { fontWeight: 700, fontSize: '13.5px', color: ui.pink, whiteSpace: 'nowrap' },
    rule: { fontSize: '12.5px', lineHeight: 1.5, color: ui.sub },
}

export default SalaryFactorRules
